import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetDepositPromotion from '@/modules/promotion/api/hooks/useQueryGetDepositPromotion'
import DepositPromotionListing from '@/modules/promotion/components/DepositPromotion/components/DepositPromotionListing'

function DepositPromotionPage() {
	const { pageSize, currentPage, searchQuery, selectedQuery } =
		useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: searchQuery,
		isForPlayer: selectedQuery,
	}

	const { data, isLoading } = useQueryGetDepositPromotion(payload)

	return (
		<PageContainer>
			<DepositPromotionListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedDepositPromotionPage = withUserPermission(DepositPromotionPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_DEPOSIT_PROMOTION],
})

export default GuardedDepositPromotionPage
